(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import PropTypes from 'prop-types';
import styled from 'styled-components';
import Div from "./Div.js";
var Flex = styled(Div).withConfig({
  displayName: "Flex",
  componentId: "sc-iga4yc-0"
})(["display:flex;", " ", " ", " ", " ", " ", ""], function (props) {
  return props.stretch && "\n    justify-content: stretch;\n    align-items: stretch;\n  ";
}, function (props) {
  return props.justifyContent && "justify-content: ".concat(props.justifyContent, ";");
}, function (props) {
  return props.alignItems && "align-items: ".concat(props.alignItems, ";");
}, function (props) {
  return props.alignSelf && "align-self: ".concat(props.alignSelf, ";");
}, function (props) {
  return props.flexDirection && "flex-direction: ".concat(props.flexDirection, ";");
}, function (props) {
  return props.direction && "flex-direction: ".concat(props.direction, ";");
});
Flex.propTypes = {
  stretch: PropTypes.bool,
  justifyContent: PropTypes.string,
  alignItems: PropTypes.string,
  alignSelf: PropTypes.string,
  flexDirection: PropTypes.string,
  direction: PropTypes.string
};
var _default = Flex;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Flex, "Flex", "/home/vsts/work/1/s/src/components/layout/Flex.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/layout/Flex.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();